// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"a11bab5e","709":"856e42e5","809":"eb413fe2"}[chunkId] + ".chunk.js";
};